import React from 'react';

import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { useExtra } from 'apps/auth/hooks/selectors';

import FeedbackCancellationReasons from './FeedbackCancellationReasons';

const CanceledWebPinSetupModal = () => {
    const { showFeedbackCancellationReasons } = useExtra();

    return (
        <ModalComponent canCloseModal={false} isVerticalCentered>
            {showFeedbackCancellationReasons && <FeedbackCancellationReasons />}
        </ModalComponent>
    );
};

export default CanceledWebPinSetupModal;
